export const leadsDataList = [
  {
    key:"1",
    LeadName: "Collins",
    CompanyName: "BrightWave Innovations",
    Phone: "(123) 4567 890",
    Email: "anthony@example.com",
    Tags: "Closed",
    CreatedDate: "14 Jan 2024",
    Image: "company-01.svg",
    LeadOwner: "Hendry Milner",
  },
  {
    key:"2",
    LeadName: "Konopelski",
    CompanyName: "Stellar Dynamics",
    Phone: "(179) 7382 829",
    Email: "brian@example.com",
    Tags: "Contacted",
    CreatedDate: "21 Jan 2024",
    Image: "company-02.svg",
    LeadOwner: "Guilory Berggren",
  },
  {
    key:"3",
    LeadName: "Adams",
    CompanyName: "Quantum Nexus",
    Phone: "(184) 2719 738",
    Email: "harvey@example.com",
    Tags: "Lost",
    CreatedDate: "20 Feb 2024",
    Image: "company-03.svg",
    LeadOwner: "Jami Carlile",
  },
  {
    key:"4",
    LeadName: "Schumm",
    CompanyName: "EcoVision Enterprises",
    Phone: "(193) 7839 748",
    Email: "peral@example.com",
    Tags: "Not Contacted",
    CreatedDate: "15 Mar 2024",
    Image: "company-04.svg",
    LeadOwner: "Theresa Nelson",
  },
  {
    key:"5",
    LeadName: "Wisozk",
    CompanyName: "Aurora Technologies",
    Phone: "(183) 9302 890",
    Email: "martniwr@example.com",
    Tags: "Closed",
    CreatedDate: "12 Apr 2024",
    Image: "company-05.svg",
    LeadOwner: "Smith Cooper",
  },
  {
    key:"6",
    LeadName: "Heller",
    CompanyName: "BlueSky Ventures",
    Phone: "(120) 3728 039",
    Email: "ray456@example.com",
    Tags: "Contacted",
    CreatedDate: "20 May 2024",
    Image: "company-06.svg",
    LeadOwner: "Martin Lewis",
  },
  {
    key:"7",
    LeadName: "Gutkowski",
    CompanyName: "TerraFusion Energy",
    Phone: "(102) 8480 832",
    Email: "murray@example.com",
    Tags: "Not Contacted",
    CreatedDate: "06 Jul 2024",
    Image: "company-07.svg",
    LeadOwner: "Newell Egan",
  },
  {
    key:"8",
    LeadName: "Walter",
    CompanyName: "UrbanPulse Design",
    Phone: "(162) 8920 713",
    Email: "smtih@example.com",
    Tags: "Closed",
    CreatedDate: "02 Sep 2024",
    Image: "company-08.svg",
    LeadOwner: "Janet Carlson",
  },
  {
    key:"9",
    LeadName: "Hansen",
    CompanyName: "Nimbus Networks",
    Phone: "(189) 0920 723",
    Email: "connie@example.com",
    Tags: "Closed",
    CreatedDate: "15 Nov 2024",
    Image: "company-09.svg",
    LeadOwner: "Craig Brown",
  },
  {
    key:"10",
    LeadName: "Leuschke",
    CompanyName: "Epicurean Delights",
    Phone: "(168) 8392 823",
    Email: "broaddus@example.com",
    Tags: "Lost",
    CreatedDate: "10 Dec 2024",
    Image: "company-10.svg",
    LeadOwner: "Daniel Byrne",
  },
];
